const COLLECTION_TYPES = {
  PARENT_COLLECTION: 'PARENT_COLLECTION',
  CUSTOM_COLLECTION: 'CUSTOM_COLLECTION',
};

const COLLECTION_COLORWAY_PICKER_ITEM_TYPES = {
  NAVIGATION_ARROW_PREV: 'NAVIGATION_ARROW_PREV',
  NAVIGATION_ARROW_NEXT: 'NAVIGATION_ARROW_NEXT',
  COLORWAY: 'COLORWAY',
  EMPTY: 'EMPTY',
};

const COLLECTION_COLORWAY_PICKER_APPEARANCES = {
  COLOR_SWATCHES: 'COLOR_SWATCHES',
  THUMBNAILS: 'THUMBNAILS',
};

export {
  COLLECTION_TYPES,
  COLLECTION_COLORWAY_PICKER_ITEM_TYPES,
  COLLECTION_COLORWAY_PICKER_APPEARANCES,
};
